export default function SkillTag({ skill }) {
  return (
    <span className="px-4 py-2 bg-emerald-600/30 text-emerald-200 rounded-full text-sm border border-emerald-400/20">
      {skill}
    </span>
  );
}